import axios from 'axios';

const API_URL = process.env.VUE_APP_AUTH_SERVICE_API_URL;

class AuthService {
  signin(token) {
    return axios
      .post(API_URL + 'signin', token)
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  login(user) {
    return axios
      .post(API_URL + `login`, user)
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  forgotPassword(user) {
    return axios.post(API_URL + `forgot_password`, user);
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      UserID: user.UserID,
      FullName: user.FullName,
      Email: user.Email,
      Authorisers: user.Authorisers,
      Mobile: user.Mobile,
      UserIsDisabled: user.UserIsDisabled,
      UserMustChangePassword: user.UserMustChangePassword,
      AccountIsLockedOut: user.AccountIsLockedOut,
      IsPrimaryOfficer: user.IsPrimaryOfficer,
      IsSecondaryOfficer: user.IsSecondaryOfficer,
      MakerID: user.MakerID,
      LastUserID: user.LastUserID,
    });
  }
}

export default new AuthService();
